if (!window.ShopifyProductManagerDefined) {
  window.ShopifyProductManagerDefined = true;

  function safeForEach(collection, callback) {
    if (!collection || !collection.forEach) return;
    try {
      collection.forEach(callback);
    } catch (error) {
    }
  }

  class ShopifyProductManager {
    constructor(container = document) {
      this.container = container;
      this.variants = this.getProductVariants();
      this.variant = null;
      this.swipers = { main: null, thumbs: null };
      this.isInitialLoad = true;
      this.isMainProductPage = this.checkIfMainProductPage();

      this.elements = {
        variantsJson: container.querySelector('[id^="product-variants-json"]'),
        addToCartBtn: container.querySelector('.add-to-cart'),
        qtyInput: container.querySelector('.product-qty-input'),
        inventoryEl: container.querySelector('.product-inventory'),
        priceEl: container.querySelector('.price'),
        galleryContainer: container.querySelector('.product-gallery'),
        galleryMain: container.querySelector('.product-gallery__main'),
        galleryThumbs: container.querySelector('.product-gallery__thumbs.swiper'),
        form: container.querySelector('form[action*="/cart/add"]'),
        variantInput: container.querySelector('input[name="id"]')
      };

      this.init();
    }

    getProductVariants() {
      const variantsJson = this.container.querySelector('[id^="product-variants-json"]');
      if (variantsJson) {
        try {
          return JSON.parse(variantsJson.textContent);
        } catch (e) {
        }
      }
      return window.productVariants || [];
    }

    checkIfMainProductPage() {
      const bodyClasses = document.body.className;
      if (bodyClasses.includes('template-product')) {
        return true;
      }

      const urlPath = window.location.pathname;
      if (urlPath.includes('/products/') && !urlPath.includes('/collections/')) {
        return true;
      }

      return false;
    }

    init(initialIndex = 0) {
      if (typeof Swiper !== 'undefined') {
        this.initGallery(initialIndex);
      }
      this.setupQuantityControls();
      this.initMediaInteractions();

      if (this.variants && this.variants.length > 0) {
        this.setupEventListeners();
        this.loadVariantFromURL();
        const variant = this.getvariant();

        if (variant) {
          this.variant = variant;
          this.updatePrice(variant);
          this.updateInventory(variant);
          this.updateAddToCartButton(variant);

          if (this.isInitialLoad) {
            const galleryVariant = this.getVariantForGallery();
            if (galleryVariant) {
              this.updateGalleryForVariant(galleryVariant, true);
            }
          }
        } else {
          const defaultVariant = this.selectDefaultVariant();
          if (defaultVariant) {
            this.variant = defaultVariant;
            this.updatePrice(defaultVariant);
            this.updateInventory(defaultVariant);
            this.updateAddToCartButton(defaultVariant);

            if (this.isInitialLoad) {
              const galleryVariant = this.getVariantForGallery();
              if (galleryVariant) {
                this.updateGalleryForVariant(galleryVariant, true);
              }
            }
          } else {
            this.updateInventoryNoVariant();
            this.updateAddToCartButtonNoVariant();
          }
        }

        this.updateVariantAvailability();
      } else {
        this.setupEventListeners();
        const addToCartBtn = this.elements.addToCartBtn;
        if (addToCartBtn) {
          const variantsJson = this.container.querySelector('[id^="product-variants-json"]');
          if (variantsJson) {
            try {
              const productData = JSON.parse(variantsJson.textContent);
              if (productData.length > 0 && !productData[0].available) {
                addToCartBtn.classList.add('sold-out');
                addToCartBtn.disabled = true;
                addToCartBtn.textContent = window.productStrings?.soldOut || 'Sold Out';
              }
            } catch (e) {
            }
          }
        }
      }
    }

    setupEventListeners() {
      if (this.boundHandleChange) {
        this.container.removeEventListener('change', this.boundHandleChange);
      }
      if (this.boundHandleClick) {
        this.container.removeEventListener('click', this.boundHandleClick);
      }

      this.boundHandleChange = this.handleChange.bind(this);
      this.boundHandleClick = this.handleClick.bind(this);

      this.container.addEventListener('change', this.boundHandleChange);
      this.container.addEventListener('click', this.boundHandleClick);

      const forms = this.container.querySelectorAll('form[action*="/cart/add"]');
      forms.forEach(form => {
        if (form === this.elements.form) {
          if (this.boundHandleSubmit) {
            this.elements.form.removeEventListener('submit', this.boundHandleSubmit);
          }
          this.boundHandleSubmit = this.handleSubmit.bind(this);
          this.elements.form.addEventListener('submit', this.boundHandleSubmit);
        }
      });
    }

    handleChange(event) {
      if (event.target && event.target.matches('.product-variant-value-input')) {
        this.isInitialLoad = false;
        this.handleVariantInputChange(event.target);
        this.updateVariantState();
      }
      if (event.target && event.target.matches('.variant-dropdown')) {
        this.isInitialLoad = false;
        this.handleVariantDropdownChange(event.target);
        this.updateVariantState();
      }
    }

    handleClick(event) {
      if (event.target && event.target.closest('.product-variant-value-label')) {
        const label = event.target.closest('.product-variant-value-label');
        const input = label.querySelector('.product-variant-value-input');
        if (input && !input.disabled) {
          this.isInitialLoad = false;
          this.updateCheckedStates(input);
          this.updateVariantState();
        }
      }
    }

    async handleSubmit(e) {
      if (e.defaultPrevented) {
        return;
      }

      const recipientForm = this.elements.form?.querySelector('recipient-form');
      if (recipientForm && typeof recipientForm.checkValidation === 'function') {
        const isValid = recipientForm.checkValidation();
        if (!isValid) {
          e.preventDefault();
          return;
        }
      }

      e.preventDefault();

      if (!this.variant) {
        alert(window.productStrings?.selectVariant || 'Please select an available variant.');
        return;
      }

      if (!this.variant.available) {
        this.handleErrorMessage(window.productStrings?.variantSoldOut || 'Selected variant is sold out.');
        return;
      }

      const sellingPlanInput = this.elements.form.querySelector('[name="selling_plan"]');
      const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : '';

      if (this.variant.requires_selling_plan && !sellingPlanId) {
        let message = window.productStrings?.sellingPlanRequired || 'This product requires a subscription. Please [select a plan here].';
            
        if (sellingPlanInput) {
            message = message.replace('[', '').replace(']', '');
            this.handleErrorMessage(message);
        } else {
            const productUrl = this.elements.form.dataset.productUrl || this.elements.form.getAttribute('data-product-url');
            const linkLabel = message.match(/\[(.*?)\]/)?.[1] || 'select a plan here';
            const linkHtml = `<a href="${productUrl || '#'}" style="text-decoration: underline; font-weight: bold;">${linkLabel}</a>`;
            message = message.replace(/\[.*?\]/, linkHtml);
            this.handleErrorMessage(message);
        }
        return;
      }

      if (this.elements.variantInput) {
        this.elements.variantInput.value = this.variant.id;
      }

      this.handleErrorMessage();

      const formData = {
        id: this.variant.id,
        quantity: parseInt(this.elements.qtyInput?.value || 1),
        selling_plan: sellingPlanId || undefined,
        inventory_quantity: this.variant.inventory_quantity,
        inventory_management: this.variant.inventory_management,
        inventory_policy: this.variant.inventory_policy,
        min_purchase_quantity: this.variant.min_purchase_quantity,
        max_purchase_quantity: this.variant.max_purchase_quantity
      };

      if (window.ajaxCart && typeof window.ajaxCart.addToCart === 'function') {
        const result = await window.ajaxCart.addToCart(formData, true);

        if (result && result.error) {
          this.handleErrorMessage(result.message);

          if (result.inventoryExceeded || (result.message && result.message.includes('maximum quantity'))) {
            if (window.ajaxCart.options.enableDrawer) {
              window.ajaxCart.openDrawer();
            }
          }
          return;
        }
        return;
      }

      try {
        const cartAddUrl = window.themeVariables?.routes?.cartAdd || '/cart/add.js';
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: formData.id,
            quantity: formData.quantity,
            selling_plan: formData.selling_plan,
            properties: formData.properties
          })
        });

        const data = await response.json();

        if (data.status) {
          const message = data.description || data.message || (window.productStrings?.addError || 'Error adding to cart');
          this.handleErrorMessage(message);
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
        window.location.href = '/cart';
      } catch (error) {
        this.handleErrorMessage(error.message || (window.productStrings?.unexpectedError || 'An unexpected error occurred'));
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.container.querySelector('.product-form__error-message-wrapper');
      if (this.errorMessageWrapper) {
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.innerHTML = errorMessage;
          this.errorMessageWrapper.style.cssText = 'display: block; visibility: visible; height: auto; opacity: 1;';
        } else {
          this.errorMessageWrapper.style.display = 'none';
        }
      }

      let qtyErrorDiv = null;

      if (this.elements && this.elements.qtyInput) {
        const qtyContainer = this.elements.qtyInput.closest('.product-qty-wrap') || this.elements.qtyInput.parentElement;
        if (qtyContainer) {
          if (qtyContainer.nextElementSibling && qtyContainer.nextElementSibling.classList.contains('quantity-error')) {
            qtyErrorDiv = qtyContainer.nextElementSibling;
          } else if (qtyContainer.parentElement) {
            qtyErrorDiv = qtyContainer.parentElement.querySelector('.quantity-error');
          }
        }
      }

      if (!qtyErrorDiv && this.container) {
        qtyErrorDiv = this.container.querySelector('.quantity-error');
      }

      if (qtyErrorDiv) {
        if (errorMessage) {
          qtyErrorDiv.innerHTML = errorMessage;
          qtyErrorDiv.style.cssText = 'color: #ef4444; font-size: 12px; margin-top: 5px; display: block; visibility: visible; height: auto; opacity: 1;';
        } else {
          qtyErrorDiv.textContent = '';
          qtyErrorDiv.style.display = 'none';
        }
      }

      if (errorMessage && !this.errorMessageWrapper && !qtyErrorDiv) {
        alert(errorMessage);
      }
    }

    showProductError(message) {
      this.handleErrorMessage(message);
    }

    handleVariantInputChange(input) {
      this.updateCheckedStates(input);
    }

    handleVariantDropdownChange(dropdown) {
      const group = dropdown.closest('.product-variant-group');
      const optionValueElement = group.querySelector('.option-value');
      if (optionValueElement) {
        optionValueElement.textContent = dropdown.value;
      }
    }

    updateCheckedStates(selectedInput) {
      const group = selectedInput.closest('.product-variant-group');
      const allLabelsInGroup = group.querySelectorAll('.product-variant-value-label');
      safeForEach(allLabelsInGroup, label => {
        label.classList.remove('checked');
      });

      const selectedLabel = selectedInput.closest('.product-variant-value-label');
      if (selectedLabel) {
        selectedLabel.classList.add('checked');
      }

      selectedInput.checked = true;
    }

    selectVariantOptions(variant) {
      const variantGroups = this.container.querySelectorAll('.product-variant-group');

      if (!variant || !variant.option1) {
        return;
      }

      const options = [];
      if (variant.option1) options.push(variant.option1);
      if (variant.option2) options.push(variant.option2);
      if (variant.option3) options.push(variant.option3);

      safeForEach(options, (optionValue, index) => {
        if (variantGroups[index]) {
          const radio = variantGroups[index].querySelector(`input[value="${optionValue}"]`);
          const dropdown = variantGroups[index].querySelector('.variant-dropdown');

          if (radio) {
            radio.checked = true;
            this.updateCheckedStates(radio);
          }
          if (dropdown) {
            dropdown.value = optionValue;
          }
        }
      });
    }

    initGallery(initialIndex = 0) {
      if (!this.elements.galleryContainer) return;

      const layout = this.getGalleryLayout();

      this.destroySwipers();

      if (this.elements.galleryThumbs && layout !== 'grid') {
        this.swipers.thumbs = new Swiper(this.elements.galleryThumbs, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          direction: layout === 'left' ? 'vertical' : 'horizontal',
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          passiveListeners: true,
          breakpoints: {
            0: {
              direction: layout === 'left' ? 'horizontal' : 'horizontal',
              slidesPerView: layout === 'left' ? 4 : 6
            },
            768: {
              slidesPerView: layout === 'left' ? 4 : 6
            }
          }
        });
      }

      if (this.elements.galleryMain && layout !== 'grid') {
        const mainConfig = {
          slidesPerView: layout === 'slideshow' ? 2.5 : 1,
          spaceBetween: layout === 'slideshow' ? 10 : 0,
          loop: false,
          watchSlidesProgress: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          passiveListeners: true,
          noSwiping: true,
          noSwipingSelector: '.swiper-no-swiping'
        };

        if (this.swipers.thumbs) {
          mainConfig.thumbs = { swiper: this.swipers.thumbs };
        }

        if (layout === 'grid') {
          mainConfig.allowTouchMove = false;
          mainConfig.simulateTouch = false;
        }

        this.swipers.main = new Swiper(this.elements.galleryMain, {
          ...mainConfig,
          initialSlide: initialIndex
        });

        this.swipers.main.on('slideChange', () => {
          this.updateThumbnailActiveState(this.swipers.main.activeIndex);
          this.stopActiveMedia();
        });
      }
    }

    initMediaInteractions() {
      const models = this.container.querySelectorAll('.product-model');
      models.forEach(modelContainer => {
        const prompt = modelContainer.querySelector('.product-model-prompt');
        const modelViewer = modelContainer.querySelector('model-viewer');
        const controls = modelContainer.querySelector('.product-model-controls');

        if (prompt && modelViewer) {
          const activateModel = (e) => {
            if (this.swipers.main && (this.swipers.main.animating || this.swipers.main.isMoved)) {
              return;
            }
            if (e) {
               e.preventDefault();
               e.stopPropagation();
            }
            modelContainer.classList.add('is-active');
            modelViewer.setAttribute('camera-controls', 'true');
            modelViewer.classList.add('swiper-no-swiping');
            if (this.swipers.main) {
              this.swipers.main.allowTouchMove = false;
            }
          };

          const deactivateModel = (e) => {
            if (this.swipers.main && (this.swipers.main.animating || this.swipers.main.isMoved)) {
              return;
            }
            if (e) {
               e.preventDefault();
               e.stopPropagation();
            }
            modelContainer.classList.remove('is-active');
            modelViewer.removeAttribute('camera-controls');
            modelViewer.classList.remove('swiper-no-swiping');
            if (this.swipers.main) {
              this.swipers.main.allowTouchMove = true;
            }
          };

          let startX, startY;
          const handleDown = (e) => { startX = e.clientX; startY = e.clientY; };
          const isRealTap = (e) => {
            const diffX = Math.abs(e.clientX - startX);
            const diffY = Math.abs(e.clientY - startY);
            return diffX < 10 && diffY < 10;
          };

          prompt.addEventListener('pointerdown', handleDown, { passive: true });
          prompt.addEventListener('click', (e) => {
            if (!isRealTap(e)) return;
            activateModel(e);
          });
          
          modelViewer.addEventListener('pointerdown', handleDown, { passive: true });
          modelViewer.addEventListener('click', (e) => {
            if (!isRealTap(e)) return;
            if (modelContainer.classList.contains('is-active')) {
               deactivateModel(e);
            } else {
               activateModel(e);
            }
          });
        }
        
        if (controls && modelViewer) {
          const zoomIn = controls.querySelector('.zoom-in');
          const zoomOut = controls.querySelector('.zoom-out');
          const viewInSpace = controls.querySelector('.view-in-space');
          
          if (zoomIn) zoomIn.onclick = (e) => { 
            e.preventDefault(); 
            e.stopPropagation(); 
            const fov = parseInt(modelViewer.getAttribute('field-of-view') || '45');
            modelViewer.setAttribute('field-of-view', `${Math.max(10, fov - 5)}deg`); 
          };
          if (zoomOut) zoomOut.onclick = (e) => { 
            if (e.preventDefault) e.preventDefault(); 
            if (e.stopPropagation) e.stopPropagation(); 
            const fov = parseInt(modelViewer.getAttribute('field-of-view') || '45');
            modelViewer.setAttribute('field-of-view', `${Math.min(90, fov + 5)}deg`); 
          };
          if (viewInSpace) viewInSpace.onclick = (e) => { e.preventDefault(); e.stopPropagation(); modelViewer.activateAR(); };
        }
      });

      const videoContainers = this.container.querySelectorAll('.product-video');
      videoContainers.forEach(container => {
        const prompt = container.querySelector('.product-video-prompt');
        const video = container.querySelector('video');
        const iframe = container.querySelector('iframe');

        if (prompt) {
          let startX, startY;
          prompt.addEventListener('pointerdown', (e) => { startX = e.clientX; startY = e.clientY; }, { passive: true });
          prompt.addEventListener('click', (e) => {
            const diffX = Math.abs(e.clientX - startX);
            const diffY = Math.abs(e.clientY - startY);
            if (diffX > 10 || diffY > 10) return;

            e.preventDefault();
            e.stopPropagation();
            container.classList.add('is-active');
            if (video) {
              video.play();
            } else if (iframe && iframe.contentWindow) {
              const message = iframe.src.includes('youtube') ? 
                JSON.stringify({ event: 'command', func: 'playVideo', args: '' }) :
                JSON.stringify({ method: 'play' });
              iframe.contentWindow.postMessage(message, '*');
            }
          });
        }

        if (video) {
          let vStartX, vStartY;
          video.addEventListener('pointerdown', (e) => { vStartX = e.clientX; vStartY = e.clientY; }, { passive: true });
          video.addEventListener('click', (e) => {
            const diffX = Math.abs(e.clientX - vStartX);
            const diffY = Math.abs(e.clientY - vStartY);
            if (diffX > 10 || diffY > 10) return;

            e.stopPropagation();
            if (video.paused) {
              video.play();
            } else {
              video.pause();
            }
          });
          
          video.addEventListener('play', () => { 
            video.classList.add('swiper-no-swiping');
            container.classList.add('is-active');
            if (this.swipers.main) {
              this.swipers.main.allowTouchMove = false;
            }
          });
          video.addEventListener('pause', () => { 
            video.classList.remove('swiper-no-swiping'); 
            if (this.swipers.main) {
              this.swipers.main.allowTouchMove = true;
            }
          });
          video.addEventListener('ended', () => { 
            video.classList.remove('swiper-no-swiping'); 
            if (this.swipers.main) {
              this.swipers.main.allowTouchMove = true;
            }
          });
        }
      });
    }

    stopActiveMedia() {
      if (!this.elements.galleryMain) return;

      const slides = this.elements.galleryMain.querySelectorAll('.swiper-slide');
      slides.forEach(slide => {
        const videos = slide.querySelectorAll('video');
        videos.forEach(video => {
          if (!video.paused) {
            video.pause();
          }
          video.classList.remove('swiper-no-swiping');
        });

        const iframes = slide.querySelectorAll('iframe');
        iframes.forEach(iframe => {
          if (iframe.contentWindow) {
            if (document.activeElement === iframe) {
              iframe.blur();
              window.focus();
            }
            try {
              if (iframe.src.includes('youtube.com')) {
                iframe.contentWindow.postMessage(JSON.stringify({ "event": "command", "func": "pauseVideo", "args": "" }), '*');
              } else if (iframe.src.includes('vimeo.com')) {
                iframe.contentWindow.postMessage(JSON.stringify({ "method": "pause" }), '*');
              }
            } catch (err) {
              const src = iframe.src;
              iframe.src = src;
            }
          }
        });

        const modelViewers = slide.querySelectorAll('model-viewer');
        modelViewers.forEach(model => {
          if (model.pause && typeof model.pause === 'function') {
            model.pause();
          }
          model.parentElement.classList.remove('is-active');
          model.removeAttribute('camera-controls');
          model.classList.remove('swiper-no-swiping');
        });
      });

      if (this.swipers.main) {
        this.swipers.main.allowTouchMove = true;
      }
    }

    getGalleryLayout() {
      if (!this.elements.galleryContainer) return 'default';

      if (this.elements.galleryContainer.classList.contains('product-gallery--grid')) return 'grid';
      if (this.elements.galleryContainer.classList.contains('slideshow-2p5')) return 'slideshow';
      if (this.elements.galleryContainer.classList.contains('product-gallery--left')) return 'left';
      if (this.elements.galleryContainer.classList.contains('product-gallery--bottom')) return 'bottom';
      return 'default';
    }

    destroySwipers() {
      if (this.swipers.main) {
        this.swipers.main.destroy(true, true);
        this.swipers.main = null;
      }
      if (this.swipers.thumbs) {
        this.swipers.thumbs.destroy(true, true);
        this.swipers.thumbs = null;
      }
    }

    updateThumbnailActiveState(activeIndex) {
      if (!this.elements.galleryThumbs) return;

      const thumbnails = this.elements.galleryThumbs.querySelectorAll('.swiper-slide');
      safeForEach(thumbnails, (thumb, index) => {
        thumb.classList.toggle('swiper-slide-thumb-active', index === activeIndex);
        const img = thumb.querySelector('img');
        if (img) img.classList.toggle('active', index === activeIndex);
      });
    }

    getvariant() {
      if (this.variants.length === 0) return null;

      const selectedOptions = [];
      const variantGroups = this.container.querySelectorAll('.product-variant-group');

      safeForEach(variantGroups, group => {
        const selectedRadio = group.querySelector('.product-variant-value-input:checked');
        const selectedDropdown = group.querySelector('.variant-dropdown');

        if (selectedRadio) {
          selectedOptions.push(selectedRadio.value.trim());
        } else if (selectedDropdown && selectedDropdown.value) {
          selectedOptions.push(selectedDropdown.value.trim());
        } else {
          selectedOptions.push(null);
        }
      });

      const filteredOptions = selectedOptions.filter(opt => opt !== null);

      if (filteredOptions.length === 0) return null;

      let variant = this.variants.find(v => {
        let matches = true;
        for (let i = 0; i < selectedOptions.length; i++) {
          if (selectedOptions[i] === null) continue;

          let variantOptionValue = '';
          if (i === 0) variantOptionValue = v.option1;
          else if (i === 1) variantOptionValue = v.option2;
          else if (i === 2) variantOptionValue = v.option3;

          if (!variantOptionValue || variantOptionValue.toString().trim() !== selectedOptions[i]) {
            matches = false;
            break;
          }
        }
        return matches;
      });

      if (!variant && filteredOptions.length > 0) {
        variant = this.variants.find(v => {
          return filteredOptions.every((option, index) => {
            let variantOptionValue = '';
            if (index === 0) variantOptionValue = v.option1;
            else if (index === 1) variantOptionValue = v.option2;
            else if (index === 2) variantOptionValue = v.option3;

            return variantOptionValue && variantOptionValue.toString().trim() === option;
          });
        });
      }

      return variant || null;
    }

    getVariantForGallery() {
      if (this.variant && this.variant.featured_image) {
        return this.variant;
      }
      return null;
    }

    selectDefaultVariant() {
      const availableVariant = this.variants.find(variant => variant.available);

      if (!availableVariant) {
        const firstVariant = this.variants[0];
        if (firstVariant) {
          this.selectVariantOptions(firstVariant);
          return firstVariant;
        }
        return null;
      }

      this.selectVariantOptions(availableVariant);
      return availableVariant;
    }

    updateVariantState() {
      try {
        const variant = this.getvariant();

        if (!variant && this.isInitialLoad) {
          const defaultVariant = this.selectDefaultVariant();
          this.variant = defaultVariant;
          this.isInitialLoad = false;
        } else {
          this.variant = variant;
          this.isInitialLoad = false;
        }

        const galleryVariant = this.getVariantForGallery();
        if (galleryVariant) {
          this.updateGalleryForVariant(galleryVariant);
        }

        if (this.variant) {
          const previousVariantId = this.elements.variantInput?.value;
          const variantChanged = previousVariantId != this.variant.id;

          this.updatePrice(this.variant);

          if (this.elements.inventoryEl && (variantChanged || !this.elements.inventoryEl.querySelector('.inventory-status'))) {
            this.updateInventory(this.variant);
          }

          this.updateAddToCartButton(this.variant);

          if (this.isMainProductPage) {
            this.updateURL(this.variant);
          }

          this.updateQuantityLimits(this.variant);
        } else {
          this.updateAddToCartButtonNoVariant();
          this.updateInventoryNoVariant();

          if (this.isMainProductPage) {
            this.clearURL();
          }
        }

        this.updateOptionLabels();
        this.updateVariantAvailability();
        this.updateSwatchImages();

        const variantChangedEvent = new CustomEvent('variantChanged', {
          detail: {
            variant: this.variant,
          },
        });
        document.dispatchEvent(variantChangedEvent);
      } catch (error) {
      }
    }

    updateGalleryForVariant(variant, immediate = false) {
      if (!variant?.featured_image) return;

      const targetImageSrc = this.cleanImageUrl(variant.featured_image.src);

      if (!this.swipers.main && this.elements.galleryMain) {
        const slides = this.elements.galleryMain.querySelectorAll('.swiper-slide');

        safeForEach(slides, slide => slide.classList.remove('is-active-variant'));

        safeForEach(slides, (slide) => {
          const img = slide.querySelector('img');
          if (img) {
            const imgSrc = this.cleanImageUrl(img.src);
            if (imgSrc.includes(targetImageSrc) || targetImageSrc.includes(imgSrc)) {
              slide.classList.add('is-active-variant');
              slide.scrollIntoView({ behavior: immediate ? 'auto' : 'smooth', block: 'center' });
            }
          }
        });
        return;
      }

      if (!this.swipers.main) return;

      const slides = this.elements.galleryMain.querySelectorAll('.swiper-slide');

      let targetIndex = -1;
      safeForEach(slides, (slide, index) => {
        const img = slide.querySelector('img');
        if (img) {
          const imgSrc = this.cleanImageUrl(img.src);
          if (imgSrc.includes(targetImageSrc) || targetImageSrc.includes(imgSrc)) {
            targetIndex = index;
          }
        }
      });

      if (targetIndex >= 0 && targetIndex !== this.swipers.main.activeIndex) {
        this.swipers.main.slideTo(targetIndex, immediate ? 0 : 300);
        if (this.swipers.thumbs) {
          this.swipers.thumbs.slideTo(targetIndex, immediate ? 0 : 300);
        }
      }
    }

    cleanImageUrl(url) {
      if (!url) return '';
      return url.split('?')[0].replace(/(_\d+x\d+|_grande|_large|_medium|_small|_compact|_thumb)/g, '');
    }

    updatePrice(variant) {
      if (!variant || !this.elements.priceEl) return;

      const comparePriceContainers = this.elements.priceEl.querySelectorAll('[data-compare-price]');
      const currentPriceSpans = this.elements.priceEl.querySelectorAll('[data-current-price]');
      currentPriceSpans.forEach(span => {
        span.innerHTML = this.formatMoney(variant.price);
      });

      const comparePriceValueSpans = this.elements.priceEl.querySelectorAll('[data-compare-price-value]');

      const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (isOnSale) {
        comparePriceValueSpans.forEach(span => {
          span.innerHTML = this.formatMoney(variant.compare_at_price);
        });
        this.elements.priceEl.classList.add('price--on-sale');
      } else {
        this.elements.priceEl.classList.remove('price--on-sale');
      }
      const priceBadges = this.elements.priceEl.querySelectorAll('[data-price-badge]');

      priceBadges.forEach(priceBadge => {
        const soldOutBadges = priceBadge.querySelectorAll('[data-badge-type="sold-out"]');
        const saleBadges = priceBadge.querySelectorAll('[data-badge-type="sale"]');
        const initialSoldOutBadges = priceBadge.querySelectorAll('[data-badge-type="sold-out-initial"]');
        const initialSaleBadges = priceBadge.querySelectorAll('[data-badge-type="sale-initial"]');
        const allBadges = priceBadge.querySelectorAll('[data-badge-type]');

        allBadges.forEach(badge => {
          badge.style.display = 'none';
        });

        initialSoldOutBadges.forEach(badge => badge.remove());
        initialSaleBadges.forEach(badge => badge.remove());

        if (!variant.available) {
          if (soldOutBadges.length > 0) {
            soldOutBadges.forEach(badge => {
              badge.style.display = 'inline-block';
              this.updateBadgeColorScheme(badge);
            });
            priceBadge.style.display = 'block';
          } else {
            this.createBadge(priceBadge, 'sold-out', variant);
          }
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (saleBadges.length > 0) {
            saleBadges.forEach(badge => {
              badge.style.display = 'inline-block';
              this.updateBadgeColorScheme(badge);
            });
            priceBadge.style.display = 'block';
          } else {
            this.createBadge(priceBadge, 'sale', variant);
          }
        } else {
          priceBadge.style.display = 'none';
        }
      });

      const unitPriceEls = this.elements.priceEl.querySelectorAll('[data-unit-price]');
      unitPriceEls.forEach(unitPriceEl => {
        if (variant && variant.unit_price) {
          unitPriceEl.classList.remove('hidden');

          const amountEl = unitPriceEl.querySelector('[data-unit-price-amount]');
          const baseUnitEl = unitPriceEl.querySelector('[data-unit-price-base-unit]');

          if (amountEl) {
            amountEl.innerHTML = this.formatMoney(variant.unit_price);
          }

          if (baseUnitEl && variant.unit_price_measurement) {
            let baseUnitText = '';
            const measurement = variant.unit_price_measurement;

            if (measurement.reference_value && measurement.reference_value != 1) {
              baseUnitText += measurement.reference_value;
            }

            if (measurement.reference_unit) {
              baseUnitText += measurement.reference_unit;
            }

            baseUnitEl.textContent = baseUnitText;
          }
        } else {
          unitPriceEl.classList.add('hidden');
        }
      });
    }

    createBadge(container, badgeType, variant) {
      const badgeText = badgeType === 'sold-out' ?
        (window.translations?.products?.product?.sold_out || 'Sold Out') :
        (window.translations?.products?.product?.on_sale || 'Sale');

      const colorScheme = badgeType === 'sold-out' ?
        (window.themeVariables?.settings?.sold_out_badge_color_scheme || 'scheme-4') :
        (window.themeVariables?.settings?.sale_badge_color_scheme || 'scheme-4');

      const badge = document.createElement('span');
      badge.className = `badge color-${colorScheme}`;
      badge.setAttribute('data-badge-type', badgeType);
      badge.setAttribute('data-badge-scheme', colorScheme);
      badge.textContent = badgeText;
      badge.style.display = 'inline-block';

      container.appendChild(badge);
      container.style.display = 'block';

      return badge;
    }

    updateBadgeColorScheme(badgeElement) {
      if (!badgeElement) return;

      const colorScheme = badgeElement.dataset.badgeScheme || 'scheme-4';

      badgeElement.classList.remove('color-scheme-1', 'color-scheme-2', 'color-scheme-3', 'color-scheme-4');

      badgeElement.classList.add(`color-${colorScheme}`);
    }

    updatePriceForNoVariants() {
      if (!this.elements.priceEl) return;

      let price, compareAtPrice, available;

      const productDataScript = this.container.querySelector('[id^="product-variants-json"]');
      if (productDataScript) {
        try {
          const productData = JSON.parse(productDataScript.textContent);
          if (productData.length > 0) {
            price = productData[0].price;
            compareAtPrice = productData[0].compare_at_price;
            available = productData[0].available;
          }
        } catch (e) {
        }
      }

      if ((price === undefined || price === null) && window.productData) {
        price = window.productData.price;
        compareAtPrice = window.productData.compare_at_price;
        available = window.productData.available;
      }

    }

    updateSKU(variant) {
      const skuElement = this.container.querySelector('[id^="sku-"]');
      if (!skuElement) return;

      if (variant && variant.sku && variant.sku.length > 0) {
        skuElement.textContent = variant.sku;
        skuElement.classList.remove('hidden');
      } else {
        skuElement.textContent = '';
        skuElement.classList.add('hidden');
      }
    }

    updateInventory(variant) {
      if (!this.elements.inventoryEl) return;

      if (!variant) {
        this.updateInventoryNoVariant();
        return;
      }

      const threshold = parseInt(this.elements.inventoryEl.dataset.inventoryThreshold) || 10;
      const showQuantity = this.elements.inventoryEl.dataset.showInventoryQuantity === 'true';
      const inStockText = this.elements.inventoryEl.dataset.inStockText || window.productStrings?.inStock || 'In stock';
      const lowStockText = this.elements.inventoryEl.dataset.lowStockText || window.productStrings?.lowStock || 'Low stock';
      const outOfStockText = this.elements.inventoryEl.dataset.outOfStockText || window.productStrings?.outOfStock || 'Out of stock';

      let statusClass = '';
      let statusText = '';

      const inventoryQty = variant.inventory_quantity;
      const hasInventoryTracking = variant.inventory_management === 'shopify' && inventoryQty !== null && inventoryQty !== undefined;

      if (!variant.available) {
        statusClass = 'sold-out';
        statusText = outOfStockText;
      } else if (hasInventoryTracking) {
        const qty = parseInt(inventoryQty);

        if (isNaN(qty) || qty <= 0) {
          statusClass = 'sold-out';
          statusText = outOfStockText;
        } else if (qty <= threshold) {
          statusClass = 'low-stock';
          statusText = showQuantity ? `${lowStockText} (${qty})` : lowStockText;
        } else {
          statusClass = 'available';
          statusText = showQuantity ? `${inStockText} (${qty})` : inStockText;
        }
      } else {
        statusClass = 'available';
        statusText = inStockText;
      }

      const currentContent = this.elements.inventoryEl.querySelector('.inventory-status');
      const newContent = `<span class="inventory-status ${statusClass}">${statusText}</span>`;

      if (!currentContent || currentContent.outerHTML !== newContent) {
        this.elements.inventoryEl.innerHTML = newContent;
      }

      this.elements.inventoryEl.dataset.currentInventory = inventoryQty !== null && inventoryQty !== undefined ? inventoryQty : '';
      this.elements.inventoryEl.dataset.currentAvailable = variant.available;
      this.elements.inventoryEl.dataset.currentInventoryManagement = variant.inventory_management || '';
    }

    updateInventoryForNoVariants() {
      if (!this.elements.inventoryEl) return;

      const existingStatus = this.elements.inventoryEl.querySelector('.inventory-status');
      if (existingStatus && existingStatus.textContent.trim() !== '' && !existingStatus.textContent.includes('undefined')) {
        return;
      }

      const threshold = parseInt(this.elements.inventoryEl.dataset.inventoryThreshold) || 10;
      const showQuantity = this.elements.inventoryEl.dataset.showInventoryQuantity === 'true';
      let inventoryQuantity = this.elements.inventoryEl.dataset.currentInventory;
      let available = this.elements.inventoryEl.dataset.currentAvailable;
      let inventoryManagement = this.elements.inventoryEl.dataset.currentInventoryManagement;

      if (inventoryQuantity !== undefined && inventoryQuantity !== 'null' && inventoryQuantity !== '') {
        inventoryQuantity = parseInt(inventoryQuantity);
      } else {
        inventoryQuantity = null;
      }

      if (available !== undefined && available !== 'null' && available !== '') {
        available = available === 'true';
      } else {
        available = true;
      }

      if (inventoryQuantity === null || isNaN(inventoryQuantity)) {
        const productDataScript = this.container.querySelector('#product-variants-json');
        if (productDataScript) {
          try {
            const productData = JSON.parse(productDataScript.textContent);
            if (productData.length > 0) {
              inventoryQuantity = productData[0].inventory_quantity;
              available = productData[0].available;
              inventoryManagement = productData[0].inventory_management;
            }
          } catch (e) {
          }
        }
      }

      if ((inventoryQuantity === null || isNaN(inventoryQuantity)) && window.productData) {
        inventoryQuantity = window.productData.inventory_quantity;
        available = window.productData.available;
        inventoryManagement = window.productData.inventory_management;
      }

      let statusClass = '';
      let statusText = '';

      if (!available) {
        statusClass = 'sold-out';
        statusText = 'Out of stock';
      } else if (inventoryManagement === 'shopify' && inventoryQuantity !== null && !isNaN(inventoryQuantity)) {
        const qty = parseInt(inventoryQuantity);
        if (qty <= 0) {
          statusClass = 'sold-out';
          statusText = 'Out of stock';
        } else if (qty <= threshold) {
          statusClass = 'low-stock';
          statusText = showQuantity ? `Low stock (${qty} left)` : 'Low stock';
        } else {
          statusClass = 'available';
          statusText = showQuantity ? `In stock (${qty})` : 'In stock';
        }
      } else {
        statusClass = 'available';
        statusText = 'In stock';
      }

      this.elements.inventoryEl.innerHTML = `<span class="inventory-status ${statusClass}">${statusText}</span>`;
    }

    updateInventoryNoVariant() {
      if (!this.elements.inventoryEl) return;
      const unavailableText = this.elements.inventoryEl.dataset.unavailableText || 'Unavailable';
      this.elements.inventoryEl.innerHTML = `<span class="inventory-status unavailable">${unavailableText}</span>`;
    }

    updateAddToCartButton(variant) {
      if (!this.elements.addToCartBtn) return;

      this.elements.addToCartBtn.classList.remove('sold-out', 'unavailable', 'loading');
      this.elements.addToCartBtn.disabled = false;

      if (!variant.available) {
        this.elements.addToCartBtn.classList.add('sold-out');
        this.elements.addToCartBtn.disabled = true;
        this.elements.addToCartBtn.textContent = window.productStrings?.soldOut || 'Sold Out';
      } else {
        this.elements.addToCartBtn.classList.remove('sold-out', 'unavailable');
        this.elements.addToCartBtn.textContent = window.productStrings?.addToCart || 'Add to Cart';
        this.elements.addToCartBtn.disabled = false;
      }

      if (this.elements.variantInput) {
        this.elements.variantInput.value = variant.id;
      }
    }

    updateAddToCartButtonNoVariant() {
      if (!this.elements.addToCartBtn) return;

      this.elements.addToCartBtn.classList.remove('sold-out', 'loading');
      this.elements.addToCartBtn.classList.add('unavailable');
      this.elements.addToCartBtn.disabled = true;
      this.elements.addToCartBtn.textContent = window.productStrings?.unavailable || 'Unavailable';

      if (this.elements.variantInput) {
        this.elements.variantInput.value = '';
      }
    }

    updateOptionLabels() {
      const variantGroups = this.container.querySelectorAll('.product-variant-group');
      safeForEach(variantGroups, group => {
        const selectedRadio = group.querySelector('input[type="radio"]:checked');
        const selectedDropdown = group.querySelector('.variant-dropdown');
        const optionValueElement = group.querySelector('.option-value');

        if (optionValueElement) {
          if (selectedRadio) {
            optionValueElement.textContent = selectedRadio.value;
          } else if (selectedDropdown) {
            optionValueElement.textContent = selectedDropdown.value;
          }
        }
      });
    }

    updateSwatchImages() {
      const variantGroups = this.container.querySelectorAll('.product-variant-group');
      const selectedOptions = [];
      safeForEach(variantGroups, group => {
        const selectedRadio = group.querySelector('.product-variant-value-input:checked');
        const selectedDropdown = group.querySelector('.variant-dropdown');
        if (selectedRadio) selectedOptions.push(selectedRadio.value.trim());
        else if (selectedDropdown && selectedDropdown.value) selectedOptions.push(selectedDropdown.value.trim());
        else selectedOptions.push(null);
      });

      safeForEach(variantGroups, (group, groupIndex) => {
        const inputs = group.querySelectorAll('input[type="radio"]');
        safeForEach(inputs, input => {
          const label = input.closest('.product-variant-value-label');
          if (!label) return;
          const imageSpan = label.querySelector('.variant-color-image');

          if (imageSpan) {
            if (imageSpan.dataset.isCustomSwatch === 'true') return;

            const hypotheticalSelections = [...selectedOptions];
            hypotheticalSelections[groupIndex] = input.value.trim();

            const variant = this.getMatchVariant(hypotheticalSelections);

            if (variant && variant.featured_image && variant.featured_image.src) {
              const newUrl = this.getResizedImage(variant.featured_image.src, '100x');
              imageSpan.style.backgroundImage = `url('${newUrl}')`;
            }
          }
        });
      });
    }

    getMatchVariant(options) {
      return this.variants.find(v => {
        let matches = true;
        for (let i = 0; i < options.length; i++) {
          if (options[i] === null) continue;
          let variantOptionValue = '';
          if (i === 0) variantOptionValue = v.option1;
          else if (i === 1) variantOptionValue = v.option2;
          else if (i === 2) variantOptionValue = v.option3;
          if (!variantOptionValue || variantOptionValue.toString().trim() !== options[i]) {
            matches = false;
            break;
          }
        }
        return matches;
      });
    }

    getResizedImage(url, size) {
      if (!url) return '';
      const clean = this.cleanImageUrl(url);
      const idx = clean.lastIndexOf('.');
      if (idx === -1) return clean;
      return clean.substring(0, idx) + '_' + size + clean.substring(idx);
    }

    updateURL(variant) {
      if (!variant) return;

      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    clearURL() {
      const url = new URL(window.location);
      url.searchParams.delete('variant');
      window.history.replaceState({}, '', url.toString());
    }

    updateQuantityLimits(variant) {
      if (!this.elements.qtyInput || !variant) return;

      this.elements.qtyInput.dataset.variantId = variant.id;

      let maxQuantity = 99999;

      if (variant.inventory_management && variant.inventory_policy === 'deny') {
        maxQuantity = (variant.inventory_quantity !== null && variant.inventory_quantity > 0) ? variant.inventory_quantity : 0;
      }

      if (variant.max_purchase_quantity && variant.max_purchase_quantity > 0) {
        maxQuantity = Math.min(maxQuantity, variant.max_purchase_quantity);
      }

      this.elements.qtyInput.setAttribute('max', maxQuantity);

      const minQuantity = (variant.min_purchase_quantity && variant.min_purchase_quantity > 0) ? variant.min_purchase_quantity : 1;
      this.elements.qtyInput.setAttribute('min', minQuantity);

      const currentValue = parseInt(this.elements.qtyInput.value);
      if (currentValue > maxQuantity && maxQuantity > 0) {
        this.elements.qtyInput.value = maxQuantity;
      } else if (currentValue < minQuantity) {
        this.elements.qtyInput.value = minQuantity;
      }
    }

    updateVariantAvailability() {
      try {
        const variantLabels = this.container.querySelectorAll('.product-variant-value-label');
        safeForEach(variantLabels, label => {
          label.classList.remove('variant-option-unavailable', 'soldout', 'unavailable');
          const input = label.querySelector('input');
          if (input) input.disabled = false;
        });

        const currentSelections = [];
        const variantGroups = this.container.querySelectorAll('.product-variant-group');

        safeForEach(variantGroups, group => {
          const selectedRadio = group.querySelector('input[type="radio"]:checked');
          const selectedDropdown = group.querySelector('.variant-dropdown');

          if (selectedRadio) {
            currentSelections.push(selectedRadio.value.trim());
          } else if (selectedDropdown && selectedDropdown.value) {
            currentSelections.push(selectedDropdown.value.trim());
          } else {
            currentSelections.push(null);
          }
        });

        safeForEach(variantGroups, (group, groupIndex) => {
          const inputs = group.querySelectorAll('input[type="radio"]');

          safeForEach(inputs, input => {
            try {
              const label = input.closest('.product-variant-value-label');
              const testSelections = [...currentSelections];
              testSelections[groupIndex] = input.value.trim();

              const matchingVariant = this.variants.find(variant => {
                let matches = true;
                for (let i = 0; i < testSelections.length; i++) {
                  if (testSelections[i] === null) continue;

                  let variantOptionValue = '';
                  if (i === 0) variantOptionValue = variant.option1;
                  else if (i === 1) variantOptionValue = variant.option2;
                  else if (i === 2) variantOptionValue = variant.option3;

                  if (!variantOptionValue || variantOptionValue.toString().trim() !== testSelections[i]) {
                    matches = false;
                    break;
                  }
                }
                return matches;
              });

              if (groupIndex === 0) {
                input.disabled = false;

                const firstOptionVariants = this.variants.filter(v =>
                  v.option1 && v.option1.trim() === input.value.trim()
                );

                if (firstOptionVariants.length > 0 && firstOptionVariants.every(v => !v.available)) {
                  label.classList.add('soldout');
                }
              }
              else {
                input.disabled = false;

                if (!matchingVariant) {
                  label.classList.add('variant-option-unavailable', 'unavailable');
                } else if (!matchingVariant.available) {
                  label.classList.add('variant-option-unavailable', 'soldout');
                }
              }
            } catch (error) {
            }
          });
        });
      } catch (error) {
      }
    }

    setupQuantityControls() {
      const minusBtn = this.container.querySelector('.product-qty-minus-btn');
      const plusBtn = this.container.querySelector('.product-qty-plus-btn');
      const qtyInput = this.elements.qtyInput;

      if (minusBtn && qtyInput) {
        minusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const minQuantity = parseInt(qtyInput.getAttribute('min')) || 1;
          const currentValue = parseInt(qtyInput.value) || minQuantity;

          if (currentValue > minQuantity) {
            qtyInput.value = currentValue - 1;
            qtyInput.dispatchEvent(new Event('change'));
          }
        });
      }

      if (plusBtn && qtyInput) {
        plusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const minQuantity = parseInt(qtyInput.getAttribute('min')) || 1;
          const currentValue = parseInt(qtyInput.value) || minQuantity;
          const maxValue = parseInt(qtyInput.getAttribute('max')) || 99999;

          if (currentValue >= maxValue) {
            const message = window.ajaxCart?.lastInventoryErrorMessage || '';
            if (message) {
              this.showProductError(message);
            }
            return;
          }

          qtyInput.value = currentValue + 1;
          qtyInput.dispatchEvent(new Event('change'));
        });
      }

      if (qtyInput) {
        qtyInput.addEventListener('input', () => {
          const value = qtyInput.value;
          if (value.startsWith('-')) {
            qtyInput.value = value.replace('-', '');
          }
        });

        const validate = () => {
          const value = parseInt(qtyInput.value);
          const minQuantity = parseInt(qtyInput.getAttribute('min')) || 1;
          const maxValue = parseInt(qtyInput.getAttribute('max')) || 99999;

          if (isNaN(value) || value < minQuantity) {
            qtyInput.value = minQuantity;
          } else if (value > maxValue) {
            qtyInput.value = maxValue;
          }
        };

        qtyInput.addEventListener('blur', validate);
        qtyInput.addEventListener('change', validate);
      }
    }

    loadVariantFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');

      if (!variantId) return;

      const variant = this.variants.find(v => v.id == variantId);
      if (!variant) return;

      this.selectVariantOptions(variant);
      this.variant = variant;

      this.updatePrice(variant);
      this.updateInventory(variant);
      this.updateAddToCartButton(variant);
    }

    formatMoney(cents, useCurrencyCode = false) {
      if (typeof cents === 'string') {
        cents = cents.replace(/[.,]/g, '');
        cents = parseInt(cents);
      }

      if (isNaN(cents) || cents === null || cents === undefined) {
        cents = 0;
      }

      let moneyFormat;
      if (useCurrencyCode || window.themeVariables?.settings?.currencyCodeEnabled) {
        moneyFormat = window.themeVariables?.settings?.moneyWithCurrencyFormat;
      } else {
        moneyFormat = window.themeVariables?.settings?.moneyFormat;
      }

      if (!moneyFormat) {
        moneyFormat = '{{amount}}';
      }

      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(cents, moneyFormat);
      }

      const amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{.*?\}\}/, amount);
    }

    destroy() {
      if (this.boundHandleChange) {
        this.container.removeEventListener('change', this.boundHandleChange);
      }
      if (this.boundHandleClick) {
        this.container.removeEventListener('click', this.boundHandleClick);
      }
      if (this.boundHandleSubmit && this.elements.form) {
        this.elements.form.removeEventListener('submit', this.boundHandleSubmit);
      }

      this.destroySwipers();
    }
  }

  window.ShopifyProductManager = ShopifyProductManager;
  window.productManagerInstances = window.productManagerInstances || new Map();

  function initProductManagers(container = document) {
    const mainProductContainers = container.querySelectorAll('.main-product-section, [data-section-type="product"]');

    mainProductContainers.forEach(target => {
      const sectionId = target.closest('.shopify-section')?.id || 'default';

      if (window.productManagerInstances.has(sectionId)) {
        window.productManagerInstances.get(sectionId).destroy();
      }

      const manager = new ShopifyProductManager(target);
      window.productManagerInstances.set(sectionId, manager);
    });

    if (mainProductContainers.length === 0 && document.body.classList.contains('template-product')) {
      if (window.productManagerInstances.has('document-fallback')) {
        window.productManagerInstances.get('document-fallback').destroy();
      }
      window.productManagerInstances.set('document-fallback', new ShopifyProductManager(document));
    }
  }

  document.addEventListener('DOMContentLoaded', () => initProductManagers());

  document.addEventListener('shopify:section:load', (event) => {
    initProductManagers(event.target);
  });

  function runBackgroundExtractor(container) {
    const mainProducts = container.querySelectorAll(".main-product.main-product-gallery-background");

    mainProducts.forEach(product => {
      const parentSection = product.closest(".main-product-section");
      const galleries = product.querySelectorAll(".product-gallery-wrap");

      galleries.forEach(gallery => {
        const img = gallery.querySelector(".product-image");
        if (!img) return;

        if (img.complete) {
          extractColor(img, gallery, parentSection);
        } else {
          img.addEventListener("load", () => extractColor(img, gallery, parentSection));
        }
      });
    });

    function extractColor(img, gallery, parentSection) {
      try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        let r = 0, g = 0, b = 0, count = 0;

        for (let i = 0; i < data.length; i += 40) {
          r += data[i];
          g += data[i + 1];
          b += data[i + 2];
          count++;
        }

        r = Math.floor(r / count);
        g = Math.floor(g / count);
        b = Math.floor(b / count);

        const alpha = 0.6;
        const color = `rgba(${r}, ${g}, ${b}, ${alpha})`;

        gallery.style.backgroundColor = color;
        if (parentSection) parentSection.style.backgroundColor = color;
      } catch (err) {
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    runBackgroundExtractor(document);
  });

  document.addEventListener("shopify:section:load", function (e) {
    runBackgroundExtractor(e.target);
  });

  document.addEventListener("shopify:section:select", function (e) {
    runBackgroundExtractor(e.target);
  });

  if (!customElements.get('recipient-form')) {
    customElements.define('recipient-form', class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.fieldsContainer = this.querySelector('[data-recipient-fields]');
        this.emailInput = this.querySelector('[data-recipient-email]');
        this.dateInput = this.querySelector('[data-recipient-send-on]');
        this.form = this.closest('form');

        if (this.checkbox) {
          this.checkbox.addEventListener('change', () => this.toggleFields());
          this.toggleFields();
        }

        if (this.form) {
          this.form.addEventListener('submit', (e) => this.validateForm(e));
        }

        if (this.emailInput) {
          this.emailInput.addEventListener('input', () => this.clearFieldError('email'));
        }

        if (this.dateInput) {
          this.dateInput.addEventListener('change', () => this.clearFieldError('send_on'));
        }
      }


      toggleFields() {
        if (this.checkbox.checked) {
          this.fieldsContainer.style.display = 'grid';
          this.enableInputs();
          if (this.emailInput) {
            this.emailInput.setAttribute('required', 'required');
          }
        } else {
          this.fieldsContainer.style.display = 'none';
          this.disableInputs();
          this.clearErrors();
          if (this.emailInput) {
            this.emailInput.removeAttribute('required');
          }
        }
      }

      checkValidation() {
        this.clearErrors();

        if (!this.checkbox.checked) {
          const controlInput = this.querySelector('#Recipient-Control-' + this.dataset.sectionId);
          if (controlInput) {
            controlInput.value = '';
          }
          return true;
        }

        const emailValue = this.emailInput?.value?.trim() || '';

        if (!emailValue) {
          this.showEmailError(this.getTranslation('email_required', 'Please enter a recipient email address'));
          return false;
        }



        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

        if (!emailRegex.test(emailValue)) {
          this.showEmailError(this.getTranslation('email_invalid', 'Please enter a valid email address'));
          return false;
        }

        const sendOnInput = this.querySelector('[data-recipient-send-on]');
        if (sendOnInput && sendOnInput.value) {
          const sendDate = new Date(sendOnInput.value);
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          if (sendDate < today) {
            this.showError('send_on', this.getTranslation('date_past', 'Send date cannot be in the past'));
            return false;
          }

          const maxDate = new Date();
          maxDate.setDate(maxDate.getDate() + 90);
          maxDate.setHours(0, 0, 0, 0);

          if (sendDate > maxDate) {
            this.showError('send_on', this.getTranslation('date_future', 'Send date must be within 90 days from today'));
            return false;
          }
        }


        return true;
      }

      validateForm(e) {
        const isValid = this.checkValidation();
        if (!isValid && e) {
          e.preventDefault();
        }
        return isValid;
      }

      getTranslation(key, fallback) {
        const translations = {
          email_required: this.dataset.emailRequiredText,
          email_invalid: this.dataset.emailInvalidText,
          date_past: this.dataset.datePastText,
          date_future: this.dataset.dateFutureText
        };



        return translations[key] || fallback;
      }

      showError(field, message) {
        const errorWrapper = this.querySelector('.product-form-recipient-error-message-wrapper');
        if (errorWrapper) {
          errorWrapper.removeAttribute('hidden');
          const errorMessage = errorWrapper.querySelector('.form-message');
          if (errorMessage) {
            errorMessage.textContent = message;
            errorMessage.classList.remove('hidden');
            errorWrapper.style.display = 'block';
          }
        }

        const fieldId = (field || '').replace('_', '-');
        if (fieldId) {
          const errorDiv = this.querySelector(`#RecipientForm-${fieldId}-error-${this.dataset.sectionId}`);
          if (errorDiv) {
            errorDiv.classList.remove('hidden');
            errorDiv.style.display = 'block';
            const msgSpan = errorDiv.querySelector('.error-message');
            if (msgSpan) msgSpan.textContent = message;
          }
        }

        if (field === 'email' && this.emailInput) {
          this.emailInput.focus();
          this.emailInput.classList.add('error');
        }
      }



      enableInputs() {
        if (!this.fieldsContainer) return;
        const inputs = this.fieldsContainer.querySelectorAll('input, textarea');
        inputs.forEach(input => {
          input.removeAttribute('disabled');
        });
      }

      disableInputs() {
        if (!this.fieldsContainer) return;
        const inputs = this.fieldsContainer.querySelectorAll('input, textarea');
        inputs.forEach(input => {
          input.setAttribute('disabled', 'disabled');
          input.value = '';
        });
      }

      clearErrors() {
        const errorWrapper = this.querySelector('.product-form-recipient-error-message-wrapper');
        if (errorWrapper) {
          errorWrapper.setAttribute('hidden', '');
        }
        const errorMessages = this.querySelectorAll('.form-message');
        errorMessages.forEach(msg => msg.classList.add('hidden'));
      }

      clearFieldError(field) {
        const fieldId = field.replace('_', '-');
        const errorDiv = this.querySelector(`#RecipientForm-${fieldId}-error-${this.dataset.sectionId}`);
        if (errorDiv) {
          errorDiv.classList.add('hidden');
        }

        if (field === 'email' && this.emailInput) {
          this.emailInput.classList.remove('error');
        }

        const errorWrapper = this.querySelector('.product-form-recipient-error-message-wrapper');
        if (errorWrapper) {
          errorWrapper.setAttribute('hidden', '');
        }
      }



      showEmailError(message) {
        this.showError('email', message);
      }

    });
  }
}

/* size chart start */

class SizeChartPopup {
  constructor() {
    this.sizeChartBtn = document.querySelector('.product-size-chart-btn-text');
    this.sizeChartPopup = document.querySelector('.product-size-chart-drawer');
    this.sizeChartClose = document.querySelector('.product-size-chart-close');
    this.sizeChartContent = document.querySelector('.product-size-chart-drawer-content');
    this.body = document.body;
    this.mainProductSection = document.querySelector('.main-product-section');

    if (this.sizeChartBtn && this.sizeChartPopup && this.sizeChartClose && this.sizeChartContent) {
      this.init();
    }
  }

  init() {
    this.sizeChartBtn.addEventListener('click', this.openPopup.bind(this));
    this.sizeChartClose.addEventListener('click', this.closePopup.bind(this));

    this.sizeChartPopup.addEventListener('click', (e) => {
      if (e.target === this.sizeChartPopup) {
        this.closePopup(e);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.sizeChartPopup.classList.contains('show')) {
        this.closePopup(e);
      }
    });
  }

  openPopup(event) {
    event.preventDefault();
    event.stopPropagation();
    this.sizeChartPopup.classList.add('show');
    this.body.classList.add('no-scroll');
    this.togglePopupOverlay(true);
  }

  closePopup(event) {
    event.preventDefault();
    event.stopPropagation();
    this.sizeChartPopup.classList.remove('show');
    this.body.classList.remove('no-scroll');
    this.togglePopupOverlay(false);
  }

  togglePopupOverlay(isOpen) {
    if (this.mainProductSection) {
      if (isOpen) {
        this.mainProductSection.classList.add('popup-overlay');
      } else {
        this.mainProductSection.classList.remove('popup-overlay');
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new SizeChartPopup();
});

if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new SizeChartPopup();
  });
}
/* size chart end */
